<div class="attachments-container">
  <!-- Upload Button -->
  <div class="upload-section">
    <input
      type="file"
      #fileInput
      (change)="onFileSelected($event)"
      style="display: none;">
    <button mat-raised-button color="primary" (click)="fileInput.click()">
      <mat-icon>cloud_upload</mat-icon>
      UPLOAD ATTACHMENT
    </button>
  </div>

  <!-- Attachments Table -->
  <div class="attachments-table" *ngIf="attachments.length > 0">
    <table mat-table [dataSource]="attachments">
      <!-- File Name Column -->
      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef>File Name</th>
        <td mat-cell *matCellDef="let attachment">
          <div class="file-info">
            <mat-icon>insert_drive_file</mat-icon>
            <span>{{ attachment.fileName }}</span>
          </div>
        </td>
      </ng-container>

      <!-- File Size Column -->
      <ng-container matColumnDef="fileSize">
        <th mat-header-cell *matHeaderCellDef>Size</th>
        <td mat-cell *matCellDef="let attachment">{{ formatFileSize(attachment.fileSize) }}</td>
      </ng-container>

      <!-- Uploaded Date Column -->
      <ng-container matColumnDef="uploadedDate">
        <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
        <td mat-cell *matCellDef="let attachment">{{ attachment.uploadedDate | date:'MM/dd/yyyy h:mm a' }}</td>
      </ng-container>

      <!-- Uploaded By Column -->
      <ng-container matColumnDef="uploadedBy">
        <th mat-header-cell *matHeaderCellDef>Uploaded By</th>
        <td mat-cell *matCellDef="let attachment">{{ attachment.uploadedBy }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let attachment">
          <div class="action-buttons">
            <button mat-icon-button (click)="downloadAttachment(attachment)" matTooltip="Download">
              <mat-icon>download</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteAttachment(attachment.id)" matTooltip="Delete">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- Empty State -->
  <div class="empty-attachments" *ngIf="attachments.length === 0">
    <mat-icon>attach_file</mat-icon>
    <p>No attachments uploaded</p>
  </div>
</div>
